import React from 'react';
import StepperWrapper from './Stepper.style';
import propTypes from 'prop-types';


const Stepper = (props) => {
    const { steps } = props;
    return (
        <StepperWrapper>
            <div className="stepper">
                {steps.map((ele) => <span key={ele.id} className={"step lato " + ele.status}>{ele.id}</span>)}
            </div>
            <div className="stepper titles">
                {steps.map((ele) => <span key={ele.id} className={"title " + ele.status}>{ele.title}</span>)}
            </div>
        </StepperWrapper>
    );
};

Stepper.propTypes = {
    steps: propTypes.arrayOf(propTypes.exact({
        id: propTypes.number,
        title: propTypes.string,
        link:propTypes.any,
        status: propTypes.oneOf(['active', 'next', 'pending'])
    })).isRequired
}
export default Stepper;